import { render } from "./Search.vue?vue&type=template&id=3c3b06c6&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=3c3b06c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c3b06c6"

export default script